import { fetchData } from "./fetchData";

const BASE_URL = '/api/v1/cities';

const getAllCities = function () {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/', 'get')
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to fetch cities at this moment.'
        });
      })
  })
}

const getCityRequests = function (status) {
  return new Promise((resolve, reject) => {
    const query = status ? { status } : {};
    fetchData(BASE_URL + '/requests', 'get', {}, query)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to fetch city requests at this moment.'
        });
      })
  })
}

const getRequestHistory = function (requestId) {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/requests/' + requestId + '/history', 'get')
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to fetch request history at this moment.'
        });
      })
  })
}

const createCityRequest = function (data) {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/request/create', 'post', data)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to create city request at this moment.'
        });
      })
  })
}

const updateCityRequest = function (data) {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/request/update', 'post', data)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to update city request at this moment.'
        });
      })
  })
}

const approveCityRequest = function (data) {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/request/approve', 'post', data)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to approve city request at this moment.'
        });
      })
  })
}

const rejectCityRequest = function (data) {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/request/reject', 'post', data)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to reject city request at this moment.'
        });
      })
  })
}

const editPendingRequest = function (data) {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/request/edit', 'post', data)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to edit pending request at this moment.'
        });
      })
  })
}

const getPendingRequestForCity = function (params) {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/request/pending', 'get', {}, params)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to check pending request at this moment.'
        });
      })
  })
}

const getAllStates = function () {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/states', 'get')
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to fetch states at this moment.'
        });
      })
  })
}

const createState = function (data) {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/state/create', 'post', data)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to create state at this moment.'
        });
      })
  })
}

export {
  getAllCities,
  getCityRequests,
  getRequestHistory,
  createCityRequest,
  updateCityRequest,
  editPendingRequest,
  getPendingRequestForCity,
  approveCityRequest,
  rejectCityRequest,
  getAllStates,
  createState
};



// WEBPACK FOOTER //
// ./src/utils/CityApiUtils.js